import { ROUTE_NAMES } from './routeNames.const'

export const routesAppointments = [
  {
    path: '/appointments/',
    name: ROUTE_NAMES.appointments.index,
    component: () =>
      import(
        /* webpackChunkName: "Appointments" */ 'src/pages/Appointments/Appointments.vue'
      ),
  },
  {
    path: '/appointments/add',
    name: ROUTE_NAMES.appointments.add,
    component: () =>
      import(
        /* webpackChunkName: "Appointments" */ 'src/pages/Appointments/components/CreateAppointment/CreateAppointment.vue'
      ),
  },
  {
    path: '/appointments/success',
    name: ROUTE_NAMES.appointments.success,
    component: () =>
      import(
        /* webpackChunkName: "Appointments" */ 'src/pages/Appointments/components/AppointmentCreationSuccess/AppointmentCreationSuccess.vue'
      ),
    props: true,
  },
]
